export const wrapLinks = (text = ''): string => {
  const el = document.createElement('div')
  el.innerHTML = text

  wrapLinksInChild(el)

  const output = el.innerHTML

  return output
}

const wrapLinksInChild = (el: HTMLElement): void => {
  for (let i = 0; i < el.childNodes.length; i++) {
    const child = el.childNodes.item(i) as HTMLElement

    const nodeName = getNodeName(child)
    if (nodeName === 'a') {
      continue
    }

    if (child.hasChildNodes()) {
      wrapLinksInChild(child)
    } else if (nodeName === '#text') {
      wrapLinksInTextEl(child)
    }
  }
}

const expression = /(((https?:\/\/)|(www\.))([-a-zA-Z0-9@:.%/?&=_+#~])+)/gi
export const wrapLinksInTextEl = (child: HTMLElement): void => {
  const parent = child.parentElement
  const regex = new RegExp(expression)
  let value: RegExpExecArray | undefined

  let prevIndex = 0

  const text = child.textContent

  while ((value = regex.exec(text)) !== null) {
    const textBefore = text.slice(prevIndex, value.index)
    const textBeforeEl = document.createTextNode(textBefore)
    parent.insertBefore(textBeforeEl, child)

    const url = text.slice(value.index, regex.lastIndex)
    const anchorEl = document.createElement('a')
    anchorEl.setAttribute('target', '_blank')
    anchorEl.setAttribute('rel', 'noopener noreferrer')
    anchorEl.setAttribute('href', url)
    anchorEl.innerHTML = url
    parent.insertBefore(anchorEl, child)

    prevIndex = regex.lastIndex
  }

  if (prevIndex !== 0) {
    const textAfter = text.slice(prevIndex)
    const textAfterEl = document.createTextNode(textAfter)
    parent.insertBefore(textAfterEl, child)

    parent.removeChild(child)
  }
}

export const getNodeName = (el: HTMLElement): string => {
  return (el.nodeName || '').toLocaleLowerCase()
}
